class DeliveryGrid extends HTMLElement {
  constructor() {
    super();

    this.grids = this.querySelectorAll('.delivery-grid__grid');
    this.closeTokens = this.querySelectorAll('.modal-close');

    this.setEventListeners();
  }

  setEventListeners() {
    document.addEventListener('openDeliveryGrid', (e) => {
      this.open(e.detail.type);      
    });

    this.closeTokens.forEach((token) => {
      token.addEventListener('click', this.close.bind(this));
    })
  }

  open(grid) {
    this.querySelector('.grid--' + grid).classList.remove('hidden');
    this.classList.add('opened');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('opened');
    document.body.classList.remove('overflow-hidden');
    this.grids.forEach((grid) => {
      grid.classList.add('hidden');
    })
  }
}

customElements.define('delivery-grid', DeliveryGrid);
